import { API_URL, SITE } from "../components/utils/auth";

const API_ROOT = API_URL.replace(/\/+$/, "");
const PUBLIC_API_ROOT = `${API_ROOT}/public`;

async function publicApi(path, options = {}) {
  const response = await fetch(`${API_ROOT}${path}`, {
    ...options,
    headers: {
      Accept: "application/json",
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      "X-Site": SITE,
      ...options.headers,
    },
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.detail || "We could not load that information right now.");
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export function fetchSiteSettings() {
  return publicApi("/site-settings/");
}

export function submitContactMessage(data) {
  return publicApi("/contact/", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function fetchPublicLocations() {
  return publicApi(`${PUBLIC_API_ROOT.replace(API_ROOT, "")}/locations/`);
}

export function fetchLocationMenu(locationSlug) {
  return publicApi(`${PUBLIC_API_ROOT.replace(API_ROOT, "")}/locations/${locationSlug}/menu/`);
}

export function fetchLocationPaymentOptions(locationSlug) {
  return publicApi(`${PUBLIC_API_ROOT.replace(API_ROOT, "")}/locations/${locationSlug}/payment-options/`);
}

export function validateCart(payload) {
  return publicApi("/cart/validate/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function createCheckoutOrder(payload) {
  return publicApi("/checkout/orders/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchStripeConfig() {
  return publicApi("/payments/stripe/config/");
}

export function createStripePaymentIntent(payload) {
  return publicApi("/payments/stripe/create-intent/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function fetchOrderStatus(orderNumber, customerEmail = "") {
  const searchParams = new URLSearchParams();

  if (customerEmail) {
    searchParams.set("email", customerEmail);
  }

  const queryString = searchParams.toString();
  return publicApi(`/orders/${orderNumber}/${queryString ? `?${queryString}` : ""}`);
}
